import React, { useEffect, useState } from 'react';
import styles from './AdminVideos.module.css';
import { c7Api } from '../../../Logic/c7Api';
import { authCursoLogic, ClaseData } from '../../../Logic/AuthCurso';

const AdminVideos = () => {
  const [formData, setFormData] = useState({ title: '', videoid: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState("");
  const token = localStorage.getItem("token");

   const [allClasses, setAllClasses] = useState<ClaseData[]>([]);
  
    useEffect(() => {
      // Lista de todas las clases
      (async function() { 
        await authCursoLogic.GetAllClassesCurso().then((data) => {
            setAllClasses(data);
        });
      })(); 
    }, [loading]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(c7Api.getBaseUrl() + '/api/admin/videos', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, 
            'Accept': 'application/json'
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSuccess("¡Video guardado con éxito!");
        setFormData({ title: '', videoid: '' }); // Limpiar formulario
      } 
      else
        setError("Error al guardar el video");
    } catch (error: any) {
          setError(error.toString());
    } finally {
      setLoading(false);
       setTimeout(() => setError(""), 2000);
       setTimeout(() => setSuccess(""), 2000);
    }
  };

  return (<div>
            <div className={styles.adminContainer}>
                <form onSubmit={handleSubmit} className={styles.videoForm}>
                    <div className={styles.inputGroup}>
                    <label>Título de la Lección</label>
                    <input 
                        type="text" 
                        placeholder="Ej: Semana 1: Introducción"
                        value={formData.title}
                        onChange={(e) => setFormData({...formData, title: e.target.value})}
                        required 
                    />
                    </div>
                    
                    <div className={styles.inputGroup}>
                    <label>ID de Video (Vimeo)</label>
                    <input 
                        type="text" 
                        placeholder="Ej: 1153727413"
                        value={formData.videoid}
                        onChange={(e) => setFormData({...formData, videoid: e.target.value})}
                        required 
                    />
                    </div>

                    <button type="submit" disabled={loading} className={styles.saveButton}>
                    {loading ? 'Guardando...' : 'Publicar Lección'}
                    </button>
                    <div>{error && <p className={styles.error}>{error}</p>}</div>
                    <div>{success && <p className={styles.success}>{success}</p>}</div>
                </form>
            </div>

        <>
            <table className={styles.table}>
            <thead>
                <tr>
                <th>Título Lección</th>
                <th>Vimeo ID</th>
                </tr>
            </thead>
            <tbody>
                {allClasses.map((c: ClaseData) => (
                <tr>
                    <td>{c.title}</td>
                    <td>{c.youtubeid}</td>
                </tr>
                ))}
            </tbody>
            </table>
        </>
  </div>
  );
};

export default AdminVideos;